import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Nav from './components/Nav';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import HireDevelopersPage from './pages/HireDevelopersPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';

const titles: Record<string, string> = {
  '/': 'Slatewing | Build Smarter. Move Faster.',
  '/services': 'Services | Slatewing',
  '/hire-developers': 'Hire Python, AWS & DevOps Developers | Slatewing',
  '/contact': 'Get In Touch | Slatewing',
};

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    document.title = titles[pathname] ?? 'Page Not Found | Slatewing';
    if (hash) {
      // wait for the new page to render before jumping to the section
      const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' }), 100);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="app">
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/hire-developers" element={<HireDevelopersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
